import initSearchModal from './system/searchModal';

const {
  ScrollToTop,
// eslint-disable-next-line no-undef
} = jesuitsFramework;

initSearchModal();

const scrollToTop = new ScrollToTop(document.getElementById('scroll-to-top'));
scrollToTop.init();
